var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.itemBlocks != null)?_c('v-list',[_vm._l((_vm.itemBlocks),function(itemBlock,index){return [_c('BlockedItemListItem',{key:index,attrs:{"item-block":itemBlock},on:{"deleted":_vm.getItemBlocks}}),_c('v-divider',{key:index + '-divider'})]})],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }